import { ListGroup, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSearch } from "./SearchContext";
import { useEffect, useRef } from "react";
import { getMatchLabel } from "../../utils/search";

export default function SearchModal({ open, setOpen, results, loading }) {
  const { searchTerm, setSearchTerm } = useSearch();
  const inputRef = useRef(null);

  useEffect(() => {
    if (open) {
      window.setTimeout(() => {
        inputRef.current.focus();
      }, 10);
    }
  }, [open]);

  return (
    <Modal show={open} onHide={() => setOpen(false)}>
      <Modal.Header closeButton>
        <Modal.Title>Résultats de recherche</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <input
          type="text"
          ref={inputRef}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Rechercher"
          className="form-control mb-3"
        />
        {loading ? (
          <div className="d-flex justify-content-center">Recherche...</div>
        ) : (
          <ListGroup as="ul">
            {results.map((result, i) => (
              <ListGroup.Item
                key={`${result.id}-${i}`}
                as="li"
                className="mt-2 border"
              >
                <Link
                  to={result.item.url}
                  className="d-block"
                  onClick={() => setOpen(false)}
                >
                  <strong>{result.item.objType}</strong>
                  <br />
                  <span className="text-sm">{result.item.title}</span>
                  <br />
                  <span className="text-sm text-muted">
                    {getMatchLabel(result)}
                  </span>
                </Link>
              </ListGroup.Item>
            ))}
          </ListGroup>
        )}
      </Modal.Body>
      <Modal.Footer>
        {/*<Button variant="secondary" onClick={() => setOpen(false)}>*/}
        {/*  Fermer*/}
        {/*</Button>*/}
      </Modal.Footer>
    </Modal>
  );
}
